import * as Yup from 'yup';
import * as formValidation from 'utils/formValidation';

import React, { useState } from 'react';

import { AddPaymentMethod } from 'utils/payment';
import { Formik } from 'formik';
import { editUser } from 'utils/editUser';
import { logError } from 'utils/errorLogger';
import CardPaymentForm from 'components/Payment/CardPaymentForm';
import { mutate } from 'swr';
import { useMjrApiUser } from 'utils/swrCalls';

const AddCard = (props) => {
  const {
    total, type, order, buttonText, showMembership,
    setOpen, callbackFunction, showPromoCode, buttonID,
  } = props;
  const { data: user } = useMjrApiUser();
  const [state, setState] = useState({
    hasMessage: false,
    message: '',
    submit: false,
  });
  const { authNetCustomerProfileId } = user;

  const values = {
    cardNumber: '',
    expirationDate: '',
    cvv: '',
    cardholderName: '',
    billingSame: '',
    membership: false,
    firstName: '',
    lastName: '',
    address1: '',
    address2: '',
    city: '',
    state: '',
    zipCode: '',
    phone: '',
  };

  const validationSchema = Yup.object({
    cardNumber: formValidation.cardNumber,
    expirationDate: formValidation.expirationDate,
    cvv: formValidation.cvv,
    cardholderName: formValidation.cardholderName,
    billingSame: formValidation.billingSame,
    firstName: Yup.string('').when('billingSame', {
      is: (billingSame) => billingSame === 'no',
      then: formValidation.firstName,
    }),
    lastName: Yup.string('').when('billingSame', {
      is: (billingSame) => billingSame === 'no',
      then: formValidation.lastName,
    }),
    address1: Yup.string('').when('billingSame', {
      is: (billingSame) => billingSame === 'no',
      then: formValidation.address1,
    }),
    city: Yup.string('').when('billingSame', {
      is: (billingSame) => billingSame === 'no',
      then: formValidation.city,
    }),
    state: Yup.string('').when('billingSame', {
      is: (billingSame) => billingSame === 'no',
      then: formValidation.state,
    }),
    zipCode: Yup.string('').when('billingSame', {
      is: (billingSame) => billingSame === 'no',
      then: formValidation.zipCode,
    }),
    phone: Yup.string('').when('billingSame', {
      is: (billingSame) => billingSame === 'no',
      then: formValidation.phone,
    }),
  });

  /**
   * Submit
   *
   * @param data
   *
   * Submit Form
   */
  const submit = async (data) => {
    setState({
      hasMessage: false,
      message: '',
      submit: true,
    });
    const formData = data;
    formData.user = user;
    if (data.billingSame === 'yes') {
      formData.address = {
        firstName: data.cardholderName,
        lastName: '',
        address: `${user.address.addressLine1} ${user.address.addressLine2}`,
        city: user.address.city,
        state: user.address.state,
        zip: user.address.zipCode,
        country: user.address.country,
        phoneNumber: user.phone,
      };
    } else {
      formData.address = {
        firstName: data.firstName,
        lastName: data.lastName,
        address: `${data.address1} ${formData.address2}`,
        city: data.city,
        state: data.state,
        zip: data.zipCode,
        country: process.env.NEXT_PUBLIC_US_ISO_CODE,
        phoneNumber: data.phone,
      };
    }
    // pass in form data
    await AddPaymentMethod(authNetCustomerProfileId, formData)
      .then(async (response) => {
        const confirmAdd = (authNetCustomerProfileId) => {
          callbackFunction(authNetCustomerProfileId);
          setState({
            hasMessage: false,
            message: '',
            submit: false,
          });
          setOpen(false);
        };
        const result = response?.data?.messages?.resultCode;
        const returnedAuthNetCustomerProfileId = response?.data?.customerProfileId;
        // on add payment accepted
        if (result === 'Ok') {
          // if account was also created update user
          if (response?.newProfile === true) {
            const updatedUser = { ...user };
            updatedUser.authNetCustomerProfileId = returnedAuthNetCustomerProfileId;
            await editUser(updatedUser).then(async (response) => {
              if (response?.status >= 200 && response?.status <= 300) {
                mutate(`${process.env.NEXT_PUBLIC_PROXY_MJR_API_URL}/api/customer/get`);
                confirmAdd(returnedAuthNetCustomerProfileId);
              } else {
                setState({
                  hasMessage: true,
                  message: 'There was an error adding the payment method. Please refresh the page and try again.',
                  submit: false,
                });
              }
            });
          } else {
            confirmAdd(returnedAuthNetCustomerProfileId);
          }
        } else {
          logError(response, 'AddPaymentMethod(1) - /components/Payment/CardPayment/AddCard.js');
          setState({
            hasMessage: true,
            message: response?.data?.messages?.message[0]?.text,
            submit: false,
          });
        }
      })
      .catch((error) => {
        logError(error, 'AddPaymentMethod(2) - /components/Payment/CardPayment/AddCard.js');
      });
  };

  return (
    <div>
      <Formik initialValues={values} validationSchema={validationSchema} onSubmit={submit}>
        {(props) => (
          <CardPaymentForm
            {...props}
            total={total}
            order={order}
            type={type}
            buttonText={buttonText}
            buttonID={buttonID}
            showMembership={showMembership}
            showPromoCode={showPromoCode}
            message={state}
            submitting={state.submit}
          />
        )}
      </Formik>
    </div>
  );
};

export default AddCard;
